import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { delete_staff_onboarding } from "../../../data/ApiEndpoints";
import { convertStraight, formatDateTime } from "../../common-data/Converts";
import OnboardTrainerForm from "../on-boarding-form/OnboardTrainerForm";
import OnBoardingFormLanding from "../on-boarding-form/OnBoardingFormLanding";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import DetailListings from "../detail-modal/DetailListings";
import StaffOffboarding from "../off-boarding/StaffOffboarding";
import {
  BinIcon,
  CalenderIcon2,
  CheckCircleIcon,
  ClockIcon,
  CrossIcon,
  EditIcon,
  EmailIcon,
  EyeIcon,
  MobileIcon,
} from "../../../images/icons/icons";
import TrainerShiftManagement from "../shift-management/TrainerShiftManagement";
import { Hourglass } from "react-loader-spinner";
import ShiftManagement from "./ShiftManagement";
import { isDev } from "../../common-data/Commons";
import { isMemberDeleteEmail } from "../../common-data/Accessibles";

const OnboardingRequestListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
  userInfoData,
}) => {
  const dispatch = useDispatch();
  const {
    staffOnboardingRequestsLoading,
    staffOnboardingRequestsError,
    staffOnboardingRequests,
  } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isDeleteAllowed = isDev || isMemberDeleteEmail(userInfoData?.email);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModal() {
    setModValues(iniModValues);
  }

  const handleShiftTimingCallback = (action, data) => {
    if (action === "shift_timing") {
      setModValues((prevs) => ({
        ...prevs,
        isModOpen: true,
        cardName: "shift",
        rowData: data,
      }));
    } else {
      callFunction();
    }
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_staff_onboarding,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !staffOnboardingRequestsLoading &&
      !staffOnboardingRequestsError &&
      staffOnboardingRequests?.status &&
      staffOnboardingRequests?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: staffOnboardingRequests.data,
        pagination:
          staffOnboardingRequests?.pagination?.length > 0
            ? staffOnboardingRequests.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        pagination: [],
        allData: [],
      }));
    }
  }, [
    staffOnboardingRequestsLoading,
    staffOnboardingRequestsError,
    staffOnboardingRequests,
  ]);

  const tbColumns = [
    {
      dataField: "uid",
      text: "staff Details",
      formatter: (_, row) => (
        <div className="multi-row-table-td minWidth200">
          <small
            className="tb-data mid-padding mid-radius"
            style={{
              background: "#F64E60",
              color: "#fff",
              letterSpacing: "1px",
            }}
          >
            {row?.account_type?.replace(/_/g, " ") || "-"}
          </small>

          <span className="tb-data text-start">{row?.name || "NA"}</span>

          <div
            className="highlighted-dotted-line"
            style={{ border: "1px solid gray", borderStyle: "dotted" }}
          ></div>

          <small className="tb-data text-start text-initial">
            <MobileIcon /> {row?.mobile || ""}
          </small>
          <small className="tb-data text-start text-initial text-lowercase">
            <EmailIcon /> {row?.email || ""}
          </small>
          <small className="tb-data text-start text-initial">
            <CalenderIcon2 />{" "}
            {row?.date_added ? formatDateTime(row.date_added) : ""}
          </small>
        </div>
      ),
    },
    {
      dataField: "gym_id",
      text: "gym",
      formatter: (_, row) => {
        const isMultiGym =
          row?.account_type === "cluster_manager" ||
          row?.account_type === "fitness_manager" ||
          row?.account_type === "club_manager" ||
          row?.account_type === "sales_manager";

        return (
          <div className="tb-data tb-data-long text-start minWidth150">
            {isMultiGym && row?.gyms_info?.length > 0
              ? row?.gyms_info?.map((gym) => (
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        backgroundColor: "#10B981",
                        borderRadius: "50%",
                        marginRight: "6px",
                        flexShrink: 0,
                      }}
                    ></span>
                    {gym?.gym_name}{" "}
                  </>
                ))
              : row?.gym_name || "NA"}
          </div>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "HR Approval",
      formatter: (_, row) => {
        const isApprovalPending = row?.approval_status === 0;

        return (
          <span className="tb-data text-center icon minWidth120">
            {isAdmin && isApprovalPending ? (
              <button
                type="button"
                className="actionBtn"
                style={{
                  opacity: "1",
                  cursor: "pointer",
                  background: "#2973B2",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "15px",
                  padding: "10px",
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "approval",
                    rowData: row,
                  }));
                }}
              >
                hR approve
              </button>
            ) : row?.approval_status === 1 ? (
              <CheckCircleIcon />
            ) : row?.approval_status === -1 ? (
              <CrossIcon />
            ) : (
              <Hourglass />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_exists",
      text: "On Boarding	",
      formatter: (_, row) => {
        const isAppoved = row?.approval_status === 1;

        return (
          <span className="tb-data text-center icon">
            {isAdmin && isAppoved ? (
              <button
                type="button"
                className="actionBtn"
                style={{
                  opacity: "1",
                  cursor: "pointer",
                  background: row?.is_exists ? "#328300" : "#000",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "15px",
                  padding: "10px",
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "onboarding",
                    rowData: row,
                  }));
                }}
              >
                {row?.is_exists ? "completed" : "onboard"}
              </button>
            ) : row?.is_exists ? (
              <CheckCircleIcon />
            ) : (
              <Hourglass color="#d9610b" />
            )}
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "Biometric Status",
      formatter: (_, row) => {
        const isBiomatric = Number(row?.total_check_in || 0) > 0;

        return (
          <span className="tb-data text-center icon">
            {isBiomatric ? (
              <CheckCircleIcon color="#209216" />
            ) : (
              <Hourglass color="#d9610b" />
            )}
          </span>
        );
      },
    },
    {
      dataField: "joining_date",
      text: "joining date",
      formatter: (_, row) => {
        return (
          <div className="tb-data text-center minWidth100">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </div>
        );
      },
    },
    {
      dataField: "details",
      text: "view details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <EyeIcon />
            </button>
          </div>
        );
      },
    },
    isAdmin && {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => {
        const isOnboardingDone = row?.is_exists && row?.approval_status === 1;
        const isApprovalRejected = row?.approval_status === -1;
        const isTrainer = row?.account_type === "trainer";
        const isFD = row?.account_type === "receptionist";

        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon edit"
              style={{
                opacity: !isApprovalRejected ? "1" : "0.5",
                cursor: !isApprovalRejected ? "pointer" : "not-allowed",
              }}
              onClick={() =>
                !isApprovalRejected &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "edit",
                  rowData: row,
                }))
              }
            >
              <EditIcon />
            </button>

            {isOnboardingDone && (isTrainer || isFD) ? (
              <button
                type="button"
                className="actionBtn icon time"
                aria-label={`Manage shift for ${row?.name}`}
                title="Manage Shift Timing"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "shift",
                    rowData: row,
                  }))
                }
              >
                <ClockIcon color="#B4000B" />
              </button>
            ) : null}

            {isDeleteAllowed && (
              <button
                type="button"
                className="actionBtn icon delete"
                onClick={() => {
                  const filters = {
                    uid: row?.uid || "",
                  };
                  handleDelete(filters, row?.gym_name);
                }}
              >
                <BinIcon color="#B4000B" />
              </button>
            )}

            {isDeleteAllowed && (
              <button
                type="button"
                className="actionBtn icon"
                title="Staff Offboarding (F&F)"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "offboarding",
                    rowData: row,
                  }))
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="#B4000B"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                  />
                </svg>
              </button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "offboarding"
              ? "mod-offboarding-fullscreen"
              : modValues.cardName === "onboarding" ||
                modValues.cardName === "approval" ||
                modValues.cardName === "edit"
              ? "mod-width-70p"
              : modValues.cardName === "staff_photo" ||
                modValues.cardName === "view_details" ||
                modValues.cardName === "shift"
              ? "mod-width-50p"
              : "mod-width-70p"
          } ${
            modValues.cardName === "onboarding" &&
            modValues.rowData?.account_type === "cluster_manager"
              ? "mod-height-95vh"
              : ""
          } ${
            modValues.cardName === "approval" || modValues.cardName === "edit"
              ? "mod-pad-0"
              : ""
          }`}
        >
          {(modValues.cardName === "staff_photo" ||
            modValues.cardName === "view_details" ||
            modValues.cardName === "shift") && (
            <ModalHeadAndClose
              title={
                modValues.cardName === "staff_photo" ||
                modValues.cardName === "view_details"
                  ? modValues.rowData?.name
                  : modValues.cardName === "shift"
                  ? `Manage ${modValues.rowData?.account_type?.replace(
                      /_/g,
                      " "
                    )} - ${modValues.rowData?.name} Shift`
                  : modValues.cardName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />
          )}

          {modValues.cardName === "onboarding" ? (
            <OnboardTrainerForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={callFunction}
              isEdit={modValues.cardName === "edit"}
              rowData={modValues.rowData}
            />
          ) : modValues.cardName === "edit" ||
            modValues.cardName === "approval" ? (
            <OnBoardingFormLanding
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={handleShiftTimingCallback}
              isEdit={
                modValues.cardName === "edit" ||
                modValues.cardName === "approval"
              }
              isApproval={modValues.cardName === "approval"}
              rowData={modValues.rowData}
            />
          ) : modValues.cardName === "staff_photo" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.image}
                alt={modValues.rowData?.name}
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.cardName === "view_details" ? (
            <DetailListings row={modValues.rowData} />
          ) : modValues.cardName === "offboarding" ? (
            <StaffOffboarding
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
            />
          ) : modValues.cardName === "shift" &&
            (modValues.rowData?.account_type === "receptionist" ||
              modValues.rowData?.account_type === "sales_manager" ||
              modValues.rowData?.is_cluster_manager) ? (
            <ShiftManagement
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
              mainCallback={callFunction}
            />
          ) : modValues.cardName === "shift" ? (
            <div className="form-container">
              <form className="formContainer">
                <div className="formInputsGrid twoGridSystem">
                  <div className="formInputBox span2">
                    <TrainerShiftManagement
                      userInfoData={userInfoData}
                      rowData={modValues.rowData}
                      closeModal={onCloseModal}
                      callFunction={callFunction}
                      isModal={true}
                      mainCallback={callFunction}
                    />
                  </div>
                </div>
              </form>
            </div>
          ) : null}
        </div>
      </Modal>

      {staffOnboardingRequestsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table">
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        </div>
      )}
    </>
  );
};

export default OnboardingRequestListings;
